import { Box, Text } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const Container = Box.withConfig({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '1',
  fontSize: 'md',
  color: primitive.$bbqBrown,
  fontWeight: 'normal',
  lineHeight: '1.1',
});

export const Price = Text.withConfig({
  margin: '0',
  color: getDesignToken('color-validated'),
});

export const GreyStyledText = Text.withConfig({
  margin: '0',
  color: primitive.$greySix,
});

export const Divider = Text.withConfig({
  mx: { base: '1', sm: '2' },
  my: '0',
  color: primitive.$greyTwo,
});
